<template>
  <main>
    <tab-header />
    <div class="tab-content">
      <div class="tab-pane active show">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h4 class="text-green">
                        轄下未訪件接觸追蹤表
                    </h4>
                <form action="" class="form">
                  <div class="form-group">
                    <label>拜訪月份</label>
                    <select class="form-control form-control-inline" v-model="form.startYear">
                      <option
                      v-for="(year, yearIndex) in yearOpt"
                      :key="`service-year-${yearIndex}`"
                      :value="year.value">{{year.text}}</option>
                    </select>
                    <span class="text">/</span>
                    <select class="form-control form-control-inline" v-model="form.startMonth">
                      <option
                      v-for="(month, monthIndex) in monthOpt"
                      :key="`service-month-${monthIndex}`"
                      :value="month.value">{{month.text}}</option>
                    </select>
                    <span class="text">～</span>
                    <select class="form-control form-control-inline" v-model="form.endYear">
                      <option
                      v-for="(year, yearIndex) in yearOpt"
                      :key="`service-year-${yearIndex}`"
                      :value="year.value">{{year.text}}</option>
                    </select>
                    <span class="text">/</span>
                    <select class="form-control form-control-inline" v-model="form.endMonth">
                      <option
                      v-for="(month, monthIndex) in monthOpt"
                      :key="`service-month-${monthIndex}`"
                      :value="month.value">{{month.text}}</option>
                    </select>
                    <a class="btn btn-primary mt-0" @click="initSearchData()">查詢</a>
                  </div>
                </form>

                    <div class="breadcrumb row" v-if="tableRow && tableRow.length">
                        <label class="col-1 text-right">路徑</label>
                        <div class="col-7">
                            <ul class="breadcrumb-list">
                                <!-- <li :class="{
                                'active': currentLevel == null
                                }">
                                    <a role="button" @click="currentLevel = null">全部</a>
                                </li> -->
                                <li class="bread"
                                :class="{
                                'active': bread.level === currentLevel
                                }"
                                v-for="(bread, i) in breadCrumbs"
                                :key="`bread-${i}`">
                                    <a role="button" @click="currentLevel = bread.level">{{bread.name}}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-4 text-right">
                          <a @click="downloadData()" class="btn btn-default">下載本頁資料</a>
                          <a v-if="breadCrumbs[0].target != 'lev6'" @click.prevent="panelOpen('ceadcdChooseModalOpen')" class="btn btn-default">下載轄下資料</a>
                        </div>
                    </div>

                </div>
                <div class="col-12" :class="{'section-loading': isDataTreeLoading}">
                    <!-- <table class="table datatable insurance-green"  v-if="breadcrumbs.length>=1 && breadcrumbs.map(bred => bred.id).indexOf(currentLevel) == (breadcrumbs.length - 1)">
                        <thead>
                            <tr> 
                                <th>業務員姓名</th>
                                <th class="text-right">全部保戶數</th>
                                <th class="text-right">初期全單位未訪保戶數</th>
                                <th class="text-right">占率</th>
                                <th class="text-right">未訪保戶數</th>
                                <th class="text-right">減少未訪保戶數</th>
                                <th class="text-right">減少比例</th>
                            </tr>
                        </thead>
                        <tbody v-if="tableRow && tableRow.length">
                          <tr v-for="(row, rid) in tableRow" :key="`row-${rid}`">
                            <td>{{row.name}}</td>
                            <td class="text-right">{{row.allClient | numberFormat}}</td>
                            <td class="text-right">{{row.allFarClient | numberFormat}}</td>
                            <td class="text-right">{{row.allFarClientRate}}%</td>
                            <td class="text-right">{{row.farClient | numberFormat}}</td>
                            <td class="text-right">{{row.decreaseFarClient | numberFormat}}</td>
                            <td class="text-right">{{row.decreaseRate}}%</td>
                          </tr>
                        </tbody>
                        <tbody v-else-if="currentLevel && !tableRow.length">
                            <tr>
                                <td class="empty-block bg-white" colspan="7">
                                    <h1 class="bg-white">無任何資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="empty-block bg-white" colspan="7">
                                    <h1 class="bg-white">點擊查詢顯示資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot v-if="tableRow && tableRow.length">
                            <tr class="bg-white">
                                <th class="text-left">合計</th>
                                <th class="text-right">{{countTotal('allClient') | numberFormat}}</th>
                                <th class="text-right">{{countTotal('allFarClient') | numberFormat}}</th>
                                <th class="text-right">{{countTotal('allFarClientRate')}}%</th>
                                <th class="text-right">{{countTotal('farClient') | numberFormat}}</th>
                                <th class="text-right">{{countTotal('decreaseFarClient') | numberFormat}}</th>
                                <th class="text-right">{{countTotal('decreaseRate')}}%</th>
                            </tr>
                        </tfoot>
                    </table> -->

                    <table class="table datatable insurance-green">
                        <thead>
                            <tr>
                                <th>業務員姓名</th>
                                <th class="text-right">應完成人數</th>
                                <th class="text-right">已完成人數</th>
                                <th class="text-right">完成率</th>
                            </tr>
                        </thead>
                        <tbody v-if="tableRow && tableRow.length">
                          <tr v-for="(row, rid) in tableRow"
                          :key="`row-${rid}`">
                            <td>
                              <a v-if="row.child && breakType != 'lev6'" @click="searchData(row.cedvnm, row.cedvno)" class="link text-underline">{{row.cedvnm}}</a>
                              <span v-else-if="row.child">{{row.cedvnm}}</span>
                              <span v-else>{{row.cedvnm}}</span>
                            </td>
                            <!--
                            <td v-if="Number(currentLevel) < 4" class="text-right">{{row.cust}}</td>
                            <td class="text-right">{{row.z_cust}}</td>
                            <td v-if="Number(currentLevel) < 4" class="text-right">{{row.z_rate1}}%</td>
                            
                            
                            <th v-if="row.thism = """ class="text-right">0</th>
                            <th v-else class="text-right">{{row.z_remain}}<</th>
                            -->
                            <td class="text-right">{{row.thism}}</td>
                            <td class="text-right">{{row.z_remain}}</td>
                            <td class="text-right">{{row.z_remain_rate1}}%</td>
                          </tr>
                        </tbody>
                        <tbody v-else-if="currentLevel && !tableRow.length">
                            <tr>
                                <td class="empty-block bg-white" colspan="7">
                                    <h1 class="bg-white">無任何資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="empty-block bg-white" colspan="7">
                                    <h1 class="bg-white">點擊查詢顯示資料</h1>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                   
                    <div v-if="tableRow && tableRow.length">
                        如有其他疑問，請洽總公司業務部業務企劃科，(02)27551399#{{ contactInfo.contact_tel }}
                    </div>
                </div>

            </div>
        </div>
      </div>
    </div>
    <Ceadcd-Choose-Modal
      :open="ceadcdChooseModalOpen"
      :dis="dis"
      @close="panelClose('ceadcdChooseModalOpen')"
      @choose="chooseCeadcd"
    />
  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import TabHeader from '@/desktop/components/manager/TabHeader'
import ConnectDataModal from '@/desktop/components/manager/ConnectData'
import { debuglog } from 'util';
import CeadcdChooseModal from '../manager/condition/components/ceadcdChooseModal'
import { queryStatsBZEST, downloadStatsBZEST, getContactInfoBySerNo } from '../../../service'
import { saveAs } from "file-saver";

export default {
  name: 'TransferTab64',
  mixins: [commonMixin],
  components: {
    TabHeader, CeadcdChooseModal
  },
  computed: {
    tableRow () {
      return (this.dataTree && this.dataTree.length > 0) ? this.dataTree[this.dataTree.length - 1] : [];
    }
  },
  data () {
    return {
      connectModalOpen: false,
      ceadcdChooseModalOpen: false,
      order: {
          index: 1,
          asc: true
      },
      form: {
        startYear: '',
        startMonth: '',
        endYear: '',
        endMonth: '',       
      },
      yearOpt: [],
      monthOpt: [],
      isDataTreeLoading: false,
      currentLevel: 0,
      apiTarget: {},
      breadCrumbs: [],
      dataTree: [],
      breakType: '',
      dis: '51',
      contactInfo: []
    }
  },
  watch: {
    'form.startYear': function(newValue, oldValue) {this.checkDate(newValue, oldValue, 'startYear')},
    'form.startMonth': function(newValue, oldValue) {this.checkDate(newValue, oldValue, 'startMonth')},
    'form.endYear': function(newValue, oldValue) {this.checkDate(newValue, oldValue, 'endYear')},
    'form.endMonth': function(newValue, oldValue) {this.checkDate(newValue, oldValue, 'endMonth')},
    
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    initSearchData () {
      this.currentLevel = 0
      this.dataTree = []
      this.breadCrumbs = [
        {
            level: 1, 
            target: 'lev6', 
            cedvno: this.$store.state.userInfo.divNo.substring(0, 5), 
            name: this.$store.state.userInfo.divFullName
        }
      ]
      this.searchData()
    },
    searchData (name, cedvno) { 
      let target = this.breadCrumbs[0].target
      cedvno = this.breadCrumbs[0].cedvno

      let lastDay = new Date(this.form.endYear, parseInt(this.form.endMonth), 0).getDate(); //取每月最後一天
      let startDate = `${this.form.startYear}-${this.form.startMonth}-01`
      let endDate = `${this.form.endYear}-${this.form.endMonth}-${lastDay}`
      this.isDataTreeLoading = true
      queryStatsBZEST(this.$store.state.userInfo.id, target, startDate, endDate, cedvno).then(result => {
        if(result.header && result.header.status == '200') {
          let checkedDatas = result.body['query_statsbzest_' + target].map(item => {
            if(item.cedvno == '0') {
              item['child'] = false
              return item
            } else {
              item['child'] = true
              return item
            }
          })
          checkedDatas.sort(this.sortCompareFun())
          this.breakType = target
          this.dataTree.push(checkedDatas)
          this.currentLevel++
        } else {
          if(result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '查詢失敗,請重新操作'})
          }
        }
        this.isDataTreeLoading = false

        //  for 難字更新姓名
        if (target == 'lev6') {
          this.registerHanlink()
        }
      })
    },
    //下載相關功能 - START
    downloadData(targetVal) {      
      let nowBreadCrumb = this.breadCrumbs[0];
      let target = nowBreadCrumb.target;
      let cedvno =  nowBreadCrumb.cedvno;
      if(targetVal) {
        target = 'lev' + targetVal;
        cedvno = 'null';
      }
      this.isDataTreeLoading = true;
      let lastDay = new Date(this.form.endYear, parseInt(this.form.endMonth), 0).getDate(); //取每月最後一天
      let startDate = `${this.form.startYear}-${this.form.startMonth}-01`
      let endDate = `${this.form.endYear}-${this.form.endMonth}-${lastDay}`
      downloadStatsBZEST(this.$store.state.userInfo.id, target, startDate, endDate, cedvno).then(result => {
          if (result.type == "application/json") {
            //  json 為檔案下載失敗
            //  把回傳的 blob 轉為 文字檔後再用 json parse
            let reader = new FileReader();
            let vm = this;
            reader.onload = function() {
              let unicodeJsonA = JSON.parse(reader.result);
              if (unicodeJsonA.header.message) {
                vm.setToastMsg(unicodeJsonA.header.message);
              } else {
                vm.setToastMsg("伺服器連線異常");
              }
            };
            reader.readAsText(result);
          } else {
            //  成功取得檔案  進行下載
            let fileName = '轄下未訪件接觸追蹤表.xlsx';
            if(targetVal) {
              if(targetVal == '2'){
                fileName = '區部總表.xlsx';
              }else if(targetVal =='3'){
                fileName = '區部轄下通訊處總表.xlsx';
              }else if(targetVal =='4'){
                fileName = '展業轄下展業課.xlsx';
              }else if(targetVal =='5'){
                fileName = '專招轄下推展處.xlsx';
              }else if(targetVal =='6'){
                fileName = '展業轄下展業區.xlsx';
              }
            }
            saveAs(result, fileName);           
          }

          this.isDataTreeLoading = false;
        });
    },
    chooseCeadcd(val) {
      this.panelClose('ceadcdChooseModalOpen');
     this.downloadData(val);
    },
    sortCompareFun() {
      return function(a, b) {
        if(a['cedvno'] == '0') {return 1}
        if(b['cedvno'] == '0') {return -1}
        let result = (a['cedvno'] < b['cedvno']) ? -1 : (a['cedvno'] > b['cedvno']) ? 1 : 0;
        return result;
      }
    },
    initMonthOpt() {
      for(var i=1; i<13; i++) {
        let selectItem = {
          value: String(i).length == 1 ? '0' + String(i) : String(i),
          text: `${i}月`
        }
        this.monthOpt.push(selectItem)
      }
      let currentMonth = String(new Date().getMonth() +1)
      if(currentMonth.length == 1) {
        currentMonth = '0' + currentMonth
      }
      this.form.startMonth = currentMonth
      this.form.endMonth = currentMonth
    },
    initYearOpt() {
      let westYear = new Date().getFullYear()
      for(var i=westYear-5; i<=westYear; i++) {
        if(i >= 2020){
          let selectItem = {
            value: String(i),
            text: `${i - 1911}年`
          } 
        this.yearOpt.push(selectItem)                   
        }
      }
      let currentWestYear = String(westYear)
      this.form.startYear = currentWestYear
      this.form.endYear = currentWestYear
    },
    initContactInfo(){
      // 以流水編號查詢企劃單位連絡方式
      getContactInfoBySerNo(this.$store.state.userInfo.id, '11').then(result => {
        if(result && result.header.status == '200' && result.body){
            this.contactInfo  = result.body.lists[0];
        }
      })
    },
    checkDate(newValue, oldValue, buttonTag) {
      if(oldValue != ''){
        let startDate;
        let endDate;
        startDate = Date.parse(`${this.form.startYear}/${this.form.startMonth}`)
        endDate = Date.parse(`${this.form.endYear}/${this.form.endMonth}`)
            if(startDate-endDate>0){
              this.form[buttonTag] = oldValue
              this.$toast.info({title: '起年月不可小於迄年月'});
            }
      } 
    },
    initTransferTab64() {
      this.dataTree = []
      this.breadCrumbs = []
      this.currentLevel = 0
      let firstBread = {
        level: 1,
        target: '',
        name: '',
        group: null
      }

      switch(this.$store.state.userInfo.roleId) {
        case 'SALES_MANAGER_01':   // 協理
        case 'SALES_01':           // 區專
        case 'SALES_MANAGER_02':
          // 主管(經理)
        case 'SALES_MANAGER_05':
          // 主管(組訓)
          firstBread.target = '1'
          firstBread.name = '全部'
          break;
        case 'SALES_MANAGER_06':
          //被授權者
          if(this.$store.state.userInfo.userCategoryId =='A019'){
            firstBread.target = '1'
            firstBread.name = '全部'
            break;
          }else if(this.$store.state.userInfo.userCategoryId =='A044'){
            firstBread.group = this.$store.state.userInfo.divNo
            firstBread.target = '4'
            firstBread.name = this.$store.state.userInfo.divFullName
            break;
          }
          else{
            // (區主任/處長)
            firstBread.group = this.$store.state.userInfo.divNo
            if(this.$store.state.userInfo.divNo.slice(2,3) == '1') {
            // 專招人員
              firstBread.target = '5'
              firstBread.name = this.$store.state.userInfo.divFullName
            }
            if(this.$store.state.userInfo.divNo.slice(2,3) == '4') {
              // 展業人員
              firstBread.target = '6'
              firstBread.name = this.$store.state.userInfo.divFullName
            }
            break;
          }          
        case 'SALES_MANAGER_03':
          // 主管(課長)
          firstBread.group = this.$store.state.userInfo.divNo
          firstBread.target = '4'
          firstBread.name = this.$store.state.userInfo.divFullName
          break;
        case 'SALES_MANAGER_04':
          // (區主任/處長)
          firstBread.group = this.$store.state.userInfo.divNo
          if(this.$store.state.userInfo.divNo.slice(2,3) == '1') {
            // 專招人員
            firstBread.target = '5'
            firstBread.name = this.$store.state.userInfo.divFullName
          }
          if(this.$store.state.userInfo.divNo.slice(2,3) == '4') {
            // 展業人員
            firstBread.target = '6'
            firstBread.name = this.$store.state.userInfo.divFullName
          }
          break;
        default:
          this.$toast.info({title:'您無使用此頁面之權限！'})
          return;
      }
    } 
  },
  beforeMount () {
    this.initMonthOpt()
    this.initYearOpt()  
  },
  mounted () {
    //獲得企劃單位聯絡資訊
    this.initContactInfo()
  }
}
</script>
